import { connect } from 'react-redux';
import {
  getMailing,
  addMailing,
  addMailingClear
} from '../../../store/actions/adminMailing';
import MailingAdmin from './MailingAdmin';

const mapStateToProps = ({
  adminMailingReducer
}) => ({
  adminMailingReducer
});
const mapDispatchToProps = {
  getMailing,
  addMailing,
  addMailingClear
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailingAdmin);
